<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div class="LineClassPicker">
      <div v-if="!showKeyBoard">
        <van-cell icon="logistics" title="路线" :value="line.text" />
        <van-cell
          icon="clock-o"
          title="始发时间"
          :value="lineClassDay.ClassTime"
        />
        <van-cell icon="location-o" title="站点" :value="node.NodeName" />
        <van-button
          type="warning"
          block
          @click="printCheckList"
          v-if="IsShowPrintCheckList"
          >打印结算单</van-button
        >
      </div>
      <van-radio-group v-model="StartResult">
        <van-cell-group title="车辆选择">
          <van-cell
            icon="warning-o"
            v-if="VehicleList.length < 1"
            title="暂无已签到车辆"
          />
          <van-cell
            v-for="item in VehicleList"
            :key="item.GID"
            :title="item.VehicleNo + '-(' + item.PassengerSeatCount + ')'"
            clickable
            @click="onVehicleClick(item)"
            style="position: relative"
          >
            <van-radio :name="item.VehicleGID" @click="onVehicleClick(item)" />
            <div
              style="
                background-color: orange;
                height: 0.75rem;
                line-height: 0.75rem;
                position: absolute;
                right: 0.4rem;
                top: 0;
                color: #fff;
                padding: 0 0.4rem;
                border-radius: 0.5rem;
              "
              @click.stop="cancelSendCar(item)"
              v-if="item.PassengerCount != null"
            >
              取消发车
            </div>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div>
        <van-cell-group title="乘客信息" v-if="TicketInfoList.length > 0">
          <!-- <van-row>
          <van-col span="12">
            <van-cell title="已订" :value="TicketInfoList[0].BookTicketCount"/>
          </van-col>
          <van-col span="12">
            <van-cell title="含儿童" :value="TicketInfoList[0].BookChildren"/>
          </van-col>
          </van-row>-->
          <van-row>
            <van-col span="7">
              <van-cell
                title="已检"
                :value="TicketInfoList[0].CheckedTickets"
              />
            </van-col>
            <van-col span="10">
              <van-cell
                title="含儿童"
                :value="TicketInfoList[0].CheckedChildren"
              />
            </van-col>
            <van-col span="7">
              <van-cell title="未检" :value="TicketInfoList[0].NoCeckedCount" />
            </van-col>
          </van-row>
          <!-- <van-cell title="未检票" :value="TicketInfoList[0].NoCeckedCount"/> -->
          <van-row>
            <!-- 一班一车 默认为共已检票人数 -->
            <van-field
              label="本站上车人数"
              v-model="PassengerCount"
              placeholder="请输入本站上车人数"
              input-align="right"
              readonly
              @touchstart.stop="showKeyBoard = true"
            />
            <!-- <van-col span="12">
            <van-cell title="车上人数"/>
          </van-col>
          <van-col span="12">
            <van-stepper v-model="PassengerCount" min="0" integer/>
            </van-col>-->
          </van-row>
          <van-row>
            <van-col span="12">
              <van-cell title="随车人数" />
            </van-col>
            <van-col span="12">
              <van-stepper v-model="StaffCount" min="0" integer />
            </van-col>
          </van-row>
        </van-cell-group>
      </div>
      <van-row type="flex" justify="space-around" style="margin-top: 10px">
        <van-col span="6">
          <van-button
            block
            type="info"
            style="background-color: #eb5c03"
            @click="onBeforeContractReportInZero"
            v-if="showSendBtn"
            :disabled="!showSendBtn"
            >发车</van-button
          >
          <van-button
            block
            type="info"
            style="background-color: #eb5c03"
            @click="onUpdateRecord"
            v-if="!showSendBtn"
            :disabled="showSendBtn"
            >修改</van-button
          >
        </van-col>
        <van-col span="6">
          <van-button block type="default" @click="onCancel">取消</van-button>
        </van-col>
      </van-row>
    </div>
    <van-number-keyboard
      :show="showKeyBoard"
      close-button-text="完成"
      @blur="
        showKeyBoard = false;
        PassengerCount = parseInt(PassengerCount);
      "
      @input="onInput"
      @delete="onDelete"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "站点发车", //页面标题
      StaffCount: 0, //随车人数
      showKeyBoard: false, //显示数字键盘
      line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次
      node: JSON.parse(window.localStorage.getItem("lineClassDayStratNode")), //选择的站点

      ValuePeople: parseInt(this.$route.query.ValuePeople), //站点已检未上车人数
      VehicleList: [], //已签到但未发车 车辆集合
      StartResult: [], //选中发车车辆
      checkVehicle: null, //选中的车辆
      TicketInfoList: [], //站点检票信息
      PassengerCount: 0, //车上人数
      PassengerSeatCount: 0, //车辆荷载人数
      changeValue: "发车", //提示的信息
      showSendBtn: true, //显示发车或修改按钮
      IsShowPrintCheckList:
        this.$utils.getSysParams("IsShowPrintCheckList") == "1", //是否显示打印结算清单
    };
  },
  watch: {},
  methods: {
    getTrimStr(str) {
      let maxLength = str == "免" ? 4 : 6;
      let trim = "";
      for (let index = 0; index < maxLength - str.length; index++) {
        trim += " ";
      }
      return trim;
    },
    //打印结算清单
    printCheckList() {
      //连接打印
      if (window.framework) {
        //判断方法是否存在 // 连接打印机
        if (window.framework.isReadPrint) {
          window.framework.isReadPrint(true);
        }

        let params = {
          LineClassDayGID: this.lineClassDay.GID,
          StartNodeGID: this.node.NodeGID,
        };
        this.$http
          .post(
            this.$api.onTicketCheckDetailPrintQuery,
            this.$qs.stringify(params)
          )
          .then((res) => {
            if (res.success) {
              let info = res.data;
              let checkInfo = res.data.NodeTicketData;
              let str = "";
              checkInfo.forEach((item) => {
                item.FullCount = item.FullCount
                  ? item.FullCount.toString()
                  : "0";
                item.HalfCount = item.HalfCount
                  ? item.HalfCount.toString()
                  : "0";
                item.ChildCount = item.ChildCount
                  ? item.ChildCount.toString()
                  : "0";
                item.OtherCount = item.OtherCount
                  ? item.OtherCount.toString()
                  : "0";
                item.FullPrice = item.FullPrice
                  ? item.FullPrice.toString()
                  : "0";
                item.HalfPrice = item.HalfPrice
                  ? item.HalfPrice.toString()
                  : "0";
                item.OtherPrice = item.OtherPrice
                  ? item.OtherPrice.toString()
                  : "0";
                item.TotalCount = item.TotalCount
                  ? item.TotalCount.toString()
                  : "0";
                item.TotalMoney = item.TotalMoney
                  ? item.TotalMoney.toString()
                  : "0";
                str +=
                  "\n-------------------------------\n" +
                  item.NodeName +
                  ":\n数量:" +
                  item.FullCount +
                  this.getTrimStr(item.FullCount) +
                  item.HalfCount +
                  this.getTrimStr(item.HalfCount) +
                  item.OtherCount +
                  this.getTrimStr(item.OtherCount) +
                  item.ChildCount +
                  this.getTrimStr("免") +
                  item.TotalCount +
                  "\n票价:" +
                  item.FullPrice +
                  this.getTrimStr(item.FullPrice) +
                  item.HalfPrice +
                  this.getTrimStr(item.HalfPrice) +
                  item.OtherPrice +
                  this.getTrimStr(item.OtherPrice) +
                  "0" +
                  this.getTrimStr("免") +
                  item.TotalMoney;
              });
              let classdate = this.$moment(info.ClassDate).format("YYYY-MM-DD");
              let classdatetime =
                this.$moment(info.ClassDate).format("YYYY-MM-DD") +
                "  " +
                info.ClassTime;
              classdatetime =
                this.$moment(classdatetime).format("YYYY-MM-DD HH:mm");
              let jsonArray = [
                {
                  type: 1,
                  size: 2,
                  data: "  检票结算清单\n",
                },
                {
                  type: 1,
                  data:
                    "\n检票站点:" +
                    info.StartNodeName +
                    "\n打印时间:" +
                    this.$moment().format("YYYY-MM-DD HH:mm") +
                    "\n线路名称:" +
                    this.line.text +
                    "\n班次号码:" +
                    info.ClassCode +
                    "\n班次时间:" +
                    classdatetime +
                    "\n车牌号码:" +
                    info.VehicleNoList +
                    "\n司机姓名:" +
                    info.DriverNameList +
                    "\n-------------------------------\n    全票  半票  其它  免  合计" +
                    str +
                    "\n-------------------------------\n签名:\n\n\n\n------------------------------\n\n",
                },
              ];
              var admin = JSON.parse(window.localStorage.getItem("adminInfo"));
              let compGID = admin.CompGID.toUpperCase();
              let userName = admin.UserName;
              // 判断是否是广州东站
              if (compGID === "CF8B3494-7E64-465E-B243-6DB30B778DD4") {
                jsonArray = [
                  {
                    type: 1,
                    size: 2,
                    data: "  乘车人数确认单\n",
                  },
                  {
                    type: 1,
                    data:
                      "\n路线名:" +
                      this.line.text +
                      "\n发班日期:" +
                      classdate +
                      "\n班次时间:" +
                      classdatetime +
                      "\n车号:" +
                      info.VehicleNoList +
                      "\n车属单位:" +
                      info.CompNameList +
                      "\n上车点 全票数 半票数",
                  },
                ];
                let nodestr = "";
                for (let i = 0; i < info.NodeTicketData.length; i++) {
                  let nodedata = info.NodeTicketData[i];
                  nodestr +=
                    "\n" +
                    nodedata.NodeName +
                    " " +
                    nodedata.FullCount +
                    " " +
                    nodedata.ChildCount;
                }
                jsonArray[1].data +=
                  nodestr +
                  "\n司机名字:" +
                  info.DriverNameList +
                  "\n操作员:" +
                  userName +
                  "\n打单时间:" +
                  this.$moment().format("YYYY-MM-DD HH:mm");
              }

              let printStr = jsonArray[0].data + "" + jsonArray[1].data;
              if (window.framework.jsPrintJsonData) {
                window.framework.jsPrintJsonData(JSON.stringify(jsonArray));
              } else {
                window.framework.jsPrintText(printStr);
              }
            }
          });
      } else {
        this.$toast("开启打印服务失败");
      }
    },

    //更新发车信息
    onUpdateRecord() {
      //判断是否修改
      if (!this.checkVehicle) {
        return;
      }
      if (
        this.checkVehicle.PassengerCount == this.PassengerCount &&
        this.checkVehicle.StaffCount == this.StaffCount
      ) {
        this.$toast.fail("未修改数据");
        return;
      } else {
        this.$dialog
          .confirm({
            message:
              "确定要将站点上车人数:" +
              this.checkVehicle.PassengerCount +
              " 随车工作人员:" +
              this.checkVehicle.StaffCount +
              "修改为  站点上车人数:" +
              this.PassengerCount +
              " 随车工作人员:" +
              this.StaffCount +
              "?",
          })
          .then(() => {
            //修改站点上车人数 做数据校验
            //1.不允许超载
            let params = {
              LineClassDayGID: this.lineClassDay.GID,
              //VehicleGID: this.StartResult.toString(),--不传车辆参数 要校验班次所有已发送数量
              StartNodeGID: this.node.NodeGID,
            };
            this.$http
              .post(
                this.$api.getLineClassDayDepartureRecord,
                this.$qs.stringify(params)
              )
              .then((res) => {
                if (res.success) {
                  let vecount = 0;
                  let nodecount = 0;
                  res.data.forEach((item) => {
                    //获取当前班次该车已发送人数
                    if (item.VehicleGID == this.StartResult.toString()) {
                      vecount += item.PassengerCount;
                    }
                    //获取当前班次当前站点已发送人数
                    if (item.StartNodeGID == this.node.NodeGID) {
                      nodecount += item.PassengerCount;
                    }
                  });
                  //减去当前人数
                  vecount -= this.checkVehicle.PassengerCount;
                  nodecount -= this.checkVehicle.PassengerCount;
                  //1.不允许超载
                  if (this.PassengerSeatCount < this.PassengerCount + vecount) {
                    this.$toast.fail("车上人数大于核载人数，不能超载!");
                    return;
                  }
                  //2.输入人数大于于该站点已检人数
                  if (
                    this.PassengerCount > this.TicketInfoList[0].CheckedTickets
                  ) {
                    this.$toast.fail(
                      "站点上车人数:" +
                        this.PassengerCount +
                        ">站点已检人数:" +
                        this.TicketInfoList[0].CheckedTickets +
                        "。修改失败!"
                    );
                    return;
                  }
                  //3.输入人数大于于该站点未发送人数+已发送人数
                  if (
                    this.PassengerCount >
                    this.TicketInfoList[0].CheckedTickets - nodecount
                  ) {
                    this.$toast.fail(
                      "站点上车人数:" +
                        this.PassengerCount +
                        ">站点剩余人数:" +
                        (this.TicketInfoList[0].CheckedTickets - nodecount) +
                        "。修改失败!"
                    );
                    return;
                  }
                  //确认修改 更新发车记录 调用合同更新 重新报备
                  if (
                    [1, 2, 4, 5].indexOf(this.line.lineInfo.CustomMadeLevel) >
                    -1
                  ) {
                    this.onContractReport();
                  } else {
                    this.onSaveDepartureRecord();
                  }
                }
              });
          })
          .catch(() => {});
      }
    },
    //键盘输入
    onInput(value) {
      if (this.PassengerCount === 0) {
        this.PassengerCount = "";
      }
      this.PassengerCount += value.toString();
    },
    //键盘输入取消
    onDelete() {
      this.PassengerCount = 0;
    },
    //选中车辆
    onVehicleClick(item) {
      this.StartResult = item.VehicleGID;
      this.PassengerSeatCount = item.PassengerSeatCount;
      this.checkVehicle = item;

      //判断车辆是签到车辆或发车车辆
      if (item.PassengerCount != null) {
        //已经发车车辆 显示修改按钮
        this.showSendBtn = false;
        this.changeValue = "修改";
        this.PassengerCount = item.PassengerCount;
        this.StaffCount = item.StaffCount;
      } else {
        //签到车辆
        this.showSendBtn = true;
        this.changeValue = "发车";
        this.PassengerCount = 0;
        this.StaffCount = 0;
        //如果只有一辆未发车车辆 直接默认剩下所有检票人数
        let count = 0;
        this.VehicleList.forEach((ve) => {
          if (ve.PassengerCount == null) {
            count++;
          }
        });
        if (count == 1) {
          this.PassengerCount = this.ValuePeople;
        }
      }
    },
    // 取消发车
    cancelSendCar(item) {
      this.$dialog
        .confirm({
          title: "操作确认",
          message: "确定要取消车辆:" + item.VehicleNo + "的发车吗？",
        })
        .then(() => {
          this.confirmCancelSendCar(item);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 确定取消发车
    confirmCancelSendCar(item) {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.node.NodeGID,
        VehicleGID: item.VehicleGID,
      };
      this.$http
        .post(
          this.$api.onLineClassDayDepartureRecordDel,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.onQueryLineClassDayVehicleDriver();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //取消返回
    onCancel() {
      this.$router.back(-1);
    },
    onBeforeContractReportInZero() {
      if (this.StartResult.length < 1) {
        this.$toast.fail("未选择车辆");
        return;
      }
      if (this.PassengerCount <= 0) {
        this.$dialog
          .confirm({
            message: "站点上车人数为0,是否继续发车?",
          })
          .then(() => {
            //0人 判断是否存在检票人数 存在检票人数也进行报备  如果以售票人员数量报备也直接报备
            this.onBeforeContractReport();
            return;
          })
          .catch(() => {
            return;
          });
      } else {
        if ([1, 2, 4, 5].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
          this.onBeforeContractReport();
        } else {
          this.onSaveDepartureRecord();
        }
      }
    },
    //报备前校验数据
    onBeforeContractReport() {
      //2019-07-14 11:16:32 0人也能报备
      //if (this.PassengerCount <= 0) {
      //2019-07-08 10:05:00  当前站点检票人数为0时，也要能操作发车
      //this.$toast.fail("车上人数不能为0,请确认!");
      //   this.onSaveDepartureRecord();
      //   return;
      // }
      //报备时，车上人数改成本站上车人数 2019-06-20 12:27:03 xmy

      //报备前校验数据 保存发车记录
      // if (this.PassengerSeatCount < this.PassengerCount) {
      //   this.$toast.fail("车上人数大于核载人数，不能超载!");
      //   return;
      // }
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        VehicleGID: this.StartResult.toString(),
        StartNodeGID: this.node.NodeGID,
      };
      this.$http
        .post(
          this.$api.getLineClassDayDepartureRecord,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            //获取当前班次该车已发送人数
            let count = 0;
            res.data.forEach((item) => {
              count += item.PassengerCount;
            });
            //获取该站点已经检票人数
            //let checkcount = this.TicketInfoList[0].CheckedTickets;
            //1.车辆荷载人数大于已检人数+已有人数
            //checkcount + count
            if (
              this.PassengerSeatCount <
              parseInt(this.PassengerCount) + parseInt(count)
            ) {
              this.$toast.fail("车上人数大于核载人数，不能超载!");
              return;
            }
            //2.没有检票记录 不能发车
            // if (this.TicketInfoList[0].CheckedTickets <= 0) {
            //   this.$toast.fail("该班次站点没有检票数据,不能发车!");
            //   return;
            // }
            // if (count >= this.TicketInfoList[0].CheckedTickets) {
            //   this.$toast.fail("该班次站点没有未发送但已检票人员,不能发车!");
            //   return;
            // }

            //按售票人数报备
            var isRe = this.$utils.getSysParams("ReportSaleOrCheck");
            //3.输入人数大于于该站点已检人数+已有人数
            if (this.PassengerCount > this.ValuePeople && isRe === "2") {
              this.$toast.fail(
                "站点上车人数:" +
                  this.PassengerCount +
                  ">站点已检未上车人数:" +
                  this.ValuePeople +
                  "。请检查是否有未检票人上车!"
              );
              return;
            }
            //3.输入人数小于该站点已检人数+已有人数
            if (this.PassengerCount < this.ValuePeople && isRe === "2") {
              this.$dialog
                .confirm({
                  message:
                    "站点车上人数:" +
                    this.PassengerCount +
                    "<站点已检未上车人数:" +
                    this.ValuePeople +
                    "。可能有已检票人未上车,是否继续发车?",
                })
                .then(() => {
                  this.onContractReport();
                  return;
                })
                .catch(() => {
                  return;
                });
            } else {
              //人数相等的情况
              this.onContractReport();
            }
          }
        });
    },
    //发车报备
    onContractReport() {
      if (
        [
          "7818B465-1616-45C8-8F04-85F7F4F3BF52",
          "BB4C65EC-C701-4FDB-89D7-3514A5E929BB",
          "0C30EF14-CC00-4363-9207-1948743EEA51",
          "1DBB25D3-4E42-4568-936A-9D9CDC40052E",
          "AE27C5A9-22BA-405E-9682-ED180BBCABF4",
          "A77DCF3F-DA8C-40B9-93B8-896ACD96E282",
        ].indexOf(this.line.lineInfo.GID.toUpperCase()) > -1
      ) {
        this.onSaveDepartureRecord();
        return;
      }
      //报备成功 才保存发车记录 2019-07-03 17:03:09 XMY
      //报备
      let params2 = {
        LineClassDayGID: this.lineClassDay.GID,
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
        LineDayClassStationGID: this.node.NodeGID,
        StaffCount: this.StaffCount,
        VehicleGIDList: this.StartResult.toString(),
        CustomMadeLevel: this.line.lineInfo.CustomMadeLevel,
      };
      this.$http
        .post(this.$api.onContractReport, this.$qs.stringify(params2))
        .then((res) => {
          if (res.success) {
            //this.$toast.success("报备成功");
            //报备成功 保存发车记录
            this.onSaveDepartureRecord();
          }
        });
      //先保存发车数据
    },
    //保存发车数据
    onSaveDepartureRecord: function () {
      let LineClassDayDepartureRecordJsonText = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.node.NodeGID,
        VehicleGID: this.StartResult.toString(),
        StaffCount: this.StaffCount,
        PassengerCount: this.PassengerCount,
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
      };
      let params = {
        _CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        _OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        _JsonText: JSON.stringify(LineClassDayDepartureRecordJsonText),
      };
      this.$http
        .post(
          this.$api.onLineClassDayDepartureRecordSave,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.$toast.success(this.changeValue + "成功");
            this.$router.back(-1);
          } else {
            this.$toast.success(this.changeValue + "成功但发车记录保存失败");
            this.$router.back(-1);
          }
        });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    //站点检票情况查询
    onQueryNodeCheck() {
      let Nodeparams = {
        LineClassDayGID: this.lineClassDay.GID,
        NodeGID: this.node.NodeGID,
      };
      this.$http
        .post(this.$api.getStartNode, this.$qs.stringify(Nodeparams))
        .then((res) => {
          if (res.success) {
            this.TicketInfoList = res.data;
          }
        });
    },
    //班次车辆 站点检票情况查询
    onQueryLineClassDayVehicleDriver() {
      let CheckInTime = 2;
      if ([3, 4, 5, 6].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
        CheckInTime = 0;
      }
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        NodeGID: this.node.NodeGID,
        CheckInTime: CheckInTime,
      };
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.VehicleList = res.data;
            //发车时如果是一班一车默认勾选车牌，如果是一班多车无需默认勾选
            if (this.VehicleList.length > 0) {
              this.onVehicleClick(this.VehicleList[0]);
            }

            //多辆车 默认勾选第一辆未发车车辆
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].PassengerCount != null) {
                this.onVehicleClick(this.VehicleList[i]);
                return;
              }
            }
            if (!this.StartResult) {
              //所有车都已发车的情况 默认选第一辆车
              this.onVehicleClick(this.VehicleList[0]);
            }
          }
        });
    },
  },
  mounted: function () {
    this.onQueryLineClassDayVehicleDriver();
    this.onQueryNodeCheck();
  },
  created() {},
};
</script>

<style scoped lang="less">
.LineClassPicker {
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}
.van-cell__value {
  color: black;
}
.van-cell {
  font-size: 14px;
}
.van-cell__label {
  font-size: 12px;
  color: #323233;
}
.cancelSendCarShow {
  width: 80%;
  height: auto;
  text-align: center;
  font-size: 0.4rem;
  border-radius: 0.2rem;
  .title {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    background-color: #eee;
  }
  .content {
    padding: 0.4rem 0;
  }
  .btn {
    width: 100%;
    height: 0.86rem;
    line-height: 0.86rem;
    display: flex;
    justify-content: space-around;
    padding-bottom: 0.4rem;
    button {
      padding: 0 0.4rem;
      color: #fff;
      border-radius: 0.2rem;
    }
    button:first-child {
      background: #2891e7;
    }
    button:last-child {
      background: #ffb870;
    }
  }
}
</style>
